function myFixed(num, decimalPlaces) {
	var d = decimalPlaces || 0;
	var m = Math.pow(10, d);
	var n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
	var i = Math.floor(n),
		f = n - i;
	var e = 1e-8; // Allow for rounding errors in f
	var r = (f > 0.5 - e && f < 0.5 + e)
		? ((i % 2 == 0) ? i : i + 1) : Math.round(n);
	return d ? r / m : r;
}
const add = function (arg1, arg2) {
		arg1 = is_null(arg1) || is_undefined(arg1) ? 0 : arg1;
		arg2 = is_null(arg2) || is_undefined(arg2) ? 0 : arg2;
		arg1 = arg1.toString();
		arg2 = arg2.toString();
		var arg1Arr = arg1.split('.'),
			arg2Arr = arg2.split('.'),
			d1 = arg1Arr.length == 2 ? arg1Arr[1] : '',
			d2 = arg2Arr.length == 2 ? arg2Arr[1] : '';
		var maxLen = Math.max(d1.length, d2.length);
		maxLen = maxLen > 4 ? 4 : maxLen;
		var m = Math.pow(10, maxLen);
		var result = Number(((arg1 * m + arg2 * m) / m).myFixed(maxLen));
		var d = arguments[2];
		return typeof d === 'number' ? Number((result).myFixed(d)) : result;
	},
	adds = function () {
		var sum = 0;
		if (arguments.length > 1) {
			for (var i = 0; i < arguments.length; i++) {
				sum = add(sum, arguments[i]);
			}
			return sum;
		} else if (arguments.length == 1) {
			return arguments[0]
		} else {
			return 0;
		}
	},
	sub = function (arg1, arg2) {
		return calc.add(arg1, -Number(arg2), arguments[2]);
	},
	subs = function () {
		var sum = 0;
		if (arguments.length > 1) {
			for (var i = 0; i < arguments.length; i++) {
				if (i == 0)
					sum = add(sum, arguments[i]);
				else
					sum = add(sum, -Number(arguments[i]));
			}
			return sum;
		} else if (arguments.length == 1) {
			return arguments[0]
		} else {
			return 0;
		}
	},
	mul = function (arg1, arg2) {
		arg1 = is_null(arg1) || is_undefined(arg1) ? 0 : arg1;
		arg2 = is_null(arg2) || is_undefined(arg2) ? 0 : arg2;
		var r1 = arg1.toString(),
			r2 = arg2.toString(),
			m, resultVal, d = arguments[2];
		m = (r1.split('.')[1] ? r1.split('.')[1].length : 0) + (r2.split('.')[1] ? r2.split('.')[1].length
			: 0);
		resultVal = Number(r1.replace('.', '')) * Number(r2.replace('.', '')) / Math.pow(10, m);
		return typeof d !== 'number' ? Number(resultVal) : Number(resultVal.myFixed(parseInt(d)));
	},
	muls = function () {
		var sum = 0;
		if (arguments.length > 1) {
			for (var i = 0; i < arguments.length; i++) {
				if (i == 0)
					sum = arguments[i]
				else
					sum = calc.mul(sum, Number(arguments[i]));
			}
			return sum;
		} else if (arguments.length == 1) {
			return arguments[0]
		} else {
			return 0;
		}
	},
	div = function (arg1, arg2) {
		arg1 = is_null(arg1) || is_undefined(arg1) ? 0 : arg1;
		arg2 = is_null(arg2) || is_undefined(arg2) ? 0 : arg2;
		if (arg2 == 0) return 0;
		var r1 = arg1.toString(),
			r2 = arg2.toString(),
			m, resultVal, d = arguments[2];
		m = (r2.split('.')[1] ? r2.split('.')[1].length : 0) - (r1.split('.')[1] ? r1.split('.')[1].length
			: 0);
		resultVal = Number(r1.replace('.', '')) / Number(r2.replace('.', '')) * Math.pow(10, m);
		return typeof d !== 'number' ? Number(resultVal) : Number(resultVal.myFixed(parseInt(d)));
	},
	divs = function () {
		var sum = 0;
		if (arguments.length > 1) {
			for (var i = 0; i < arguments.length; i++) {
				if (i == 0)
					sum = arguments[i]
				else
					sum = div(sum, 1 / Number(arguments[i]));
			}
			return sum;
		} else if (arguments.length == 1) {
			return arguments[0]
		} else {
			return 0;
		}
	}

function is_undefined(exp) {
	return typeof (exp) == 'undefined';
}

function is_null(exp) {
	if (!exp && typeof (exp) != 'undefined' && exp != 0) {
		return true;
	}
	return false;
}

export {
	myFixed,
	add,
	adds,
	sub,
	subs,
	mul,
	muls,
	div,
	divs,
	is_undefined,
	is_null
}
